import SettingsDropdown from '@/components/component/Reuse/SettingsDropdown/SettingsDropdown.vue';
import { mapGetters } from 'vuex'
import { isEmpty } from 'lodash'
import { locationListForEntity, deleteLocation } from '@/libs/api/api'
import { message, loader } from '@/libs/helper'
import constants from '@/libs/constant/constants'
export default {

    components: { 
        SettingsDropdown,
        LocDialog: () => import('./DialogBoxes/LocDialog.vue')
    },

    created() {
        this.fetchLocations(true)
    },

    data() {
        return{
            isAddLoc: false,
            searchValue: '',
            selectedSearchValue: '',
            isFetchingLocations: false,
            isEdit: false,

            isMove: false,
            
            locationList: [{
                name: 'Accura',
                country: 'Netherlands' 
            },{
                name: 'Amazon',
                country: 'USA'
            }],

            isFetchingPeople: false,
            columns: ['name', 'country', 'settings'],
            // selectedMenu: constants.PEOPLE_LIST.MEMBER,
            selectedMenu: '',
            tableSettings: {
                headings: {
                  name: 'Name',
                  country: 'Country',
                  settings: 'Settings',
                },
                pagination: { show: false},
                perPage: 30,
                filterable: [],
                filterByColumn: true,
                sortable: ['no']
            },

            settingOptions:[
                {command: 'VIEW_LOCATION', label: 'View'},
                {command: 'EDIT_LOCATION', label: 'Edit'},
                {command: 'MOVE_LOCATION', label: 'Move'},
                {command: 'DELETE_LOCATION', label: 'Delete', isDelete: true}
            ],
            addressToBeEdited: {},
            clearLocFilter: false,
        }
    },

    computed: {
        ...mapGetters({
            locations: 'getLocations'
        })
    },

    methods: {
        // handleFilters (item) {
        //     // to set the filters
        //     this.selectedSearchValue = item.data
        //     // to clear filters
        //     this.clearLocFilter = true
        //     this.searchValue = item.data
        //     this.changePage(1)
        // },

        // changeMenu (menu) {
        //     // to clear the skip, limit and order
        //     this.clearFields()
        //     // select menu
        //     this.selectedMenu = menu
        //     // to turn on fetching 
        //     this.isFetchingPeople = true
        //     // fetch people list based on menu
        //     this.fetchPeopleList()
        // },

        changeOrderName () {
            // change sort
            // this.order = this.order === 'desc' ? 'asc' : 'desc'
            // set skip to zero
            // this.skip = 0
            // fetch people list
            // this.fetchPeopleList()
        },

        changeOrderCountry () {

        },

        setTableFilters () {
            // this.selectedTableFilters = cloneDeep(filters)
            // this.$store.dispatch('setOganisationFilters', filters)
            // if (this.selectedSearchValue === '') this.changePage(1)
        },

        resetNameFilter () {
            // this.clearLocFilter = false
        },

        querySearch(){
        },

        handleFilters (item) {
            // to set the filters
            this.selectedSearchValue = item.data
            // to clear filters
            this.clearLocFilter = true
            this.searchValue = item.data
        },

        closeInviteDialog () {
            this.isAddLoc = false
            this.isEdit = false
            this.addressToBeEdited = {}
        },

        handleCommand (option, data) {
            switch (option) {
                case 'VIEW_LOCATION':
                break
                case 'MOVE_LOCATION':
                    this.isMove = true;
                    this.isAddLoc = true
                break
                case 'EDIT_LOCATION':
                    this.isEdit = true
                    this.addressToBeEdited = data
                    this.isAddLoc = true
                break
                case 'DELETE_LOCATION': 
                    this.removeLocation(data)
                break
                
            }
        },

        /**
         * remove tree item
         * @param {*} node 
         * @param {*} data 
         */
         async removeLocation (data) {
            try {
                loader(this, true)
                // delete loc
                let response = await deleteLocation(data._id)

                // fetch locations
                this.fetchLocations(true)
                message(this, constants.messageType.SUCCESS, response.message)
            } catch (error) {
                console.error(error)
            }
            finally {
                loader(this, false)
            }

        },
        /**
         * to fetch locations
         * @param {*} isRefresh 
         */
         fetchLocations (isRefresh) {
            if (isRefresh || isEmpty(this.locations)) {
                // api call
                locationListForEntity(this.$route.params.id, {child_structure: true})
                .then(response => {
                    this.$store.dispatch('setLocations', (response.result || []))
                }).catch(error => console.error(error))
            }
        },

        /**
         * 
         * @param {*} data 
         */
        editLocation (data) {
            this.addressToBeEdited = data
            this.isEdit = true
        }
    }
}